import React from "react";
import { Button } from "../../atoms";
import { AiOutlineEye } from "react-icons/ai";
import { FcLike } from "react-icons/fc";
import { BsChat } from "react-icons/bs";

const CardReport = () => {
  return (
    <>
      <div className="my-4 border-b border-gray-light h-64">
        <img
          src="https://user-images.githubusercontent.com/5419306/64431443-71823880-d088-11e9-9bd7-1b314f94dc1f.png"
          className="bg-cover"
          alt=""
        />
        <div className="font-medium text-base text-gray-darker mb-4">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Optio, quis!
        </div>
      </div>
    </>
  );
};

export default CardReport;
